module.exports = __webpack_public_path__ + "static/media/emerald-king-rainbow-road.a5daa95c.gif";